// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__3cdto","rowsWrapper":"style_rowsWrapper__3RGMV","rowWrapper":"style_rowWrapper__oJEQq"};